import React, { ReactElement } from 'react';
import FormRadioGroup, {
  FormRadioGroupOrientation,
} from '../../../components/molecules/Form/components/FormRadioGroup/FormRadioGroup';
import { AspectRatioOption } from './ImageUploadForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';

export type UserDefinedAspectRatioSelectProps = {
  allSelectableAspectRatios: AspectRatioOption[];
  suitableSelectableAspectRatios: AspectRatioOption[];
  activeUserSelectedAspectRatio: string;
  onChangedUserSelectedAspectRatio: (aspectRatioName: string) => void;
};

export function UserDefinedAspectRatioSelect({
  allSelectableAspectRatios,
  suitableSelectableAspectRatios,
  activeUserSelectedAspectRatio,
  onChangedUserSelectedAspectRatio,
}: UserDefinedAspectRatioSelectProps): ReactElement {
  const { t } = useSonTranslation('ImageUpload');
  const id = useHtmlValidId();

  return (
    <FormRadioGroup
      id={`aspect-ratio-select-${id}`}
      legend={t('aspectRatios.legend')}
      helpText={t('aspectRatios.helpText')}
      orientation={FormRadioGroupOrientation.horizontal}
      radios={
        allSelectableAspectRatios.map((aspectRatio) => {
          return {
            name: 'aspectRatio',
            type: 'radio',
            value: aspectRatio.name,
            required: false,
            disabled: !suitableSelectableAspectRatios.some(suitableRatio => suitableRatio.name === aspectRatio.name),
          };
        }) as any[]
      }
      labels={allSelectableAspectRatios.reduce(
        (acc, element) => ({
          ...acc,
          [element.name]: t(`aspectRatios.${element.name}` as any),
        }),
        {} as any,
      )}
      selected={activeUserSelectedAspectRatio}
      onChange={(name: string, newSelectedAspectRatio: any) => {
        onChangedUserSelectedAspectRatio(newSelectedAspectRatio);
      }}
    />
  );
}
